// assets (icons)
import {
  BarChartOutlined,
  ShoppingCartOutlined,
  CreditCardOutlined
} from '@ant-design/icons';

// icons map
const icons = {
  BarChartOutlined,
  ShoppingCartOutlined,
  CreditCardOutlined
};

// ==============================|| MENU ITEMS - REPORTES ||============================== //

const support = {
  id: 'support',
  title: 'Reportes',
  type: 'group',
  children: [
    {
      id: 'sample-page',
      title: 'Reportes',
      type: 'item',
      url: '/sample-page',
      icon: icons.BarChartOutlined
    },
    {
      id: 'comprasdiarios',
      title: 'Historial de Compras',
      type: 'item',
      url: '/compradiarios',
      icon: icons.ShoppingCartOutlined
    },
    {
      id: 'pendientes',
      title: 'Historial de Creditos',
      type: 'item',
      url: '/pendientes',
      icon: icons.CreditCardOutlined
    },
    {
      id: 'vencidos',
      title: 'Clientes Vencidos',
      type: 'item',
      url: '/vencidos',
      icon: icons.CreditCardOutlined
    }
  ]
};

export default support;
